// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_0-tabs {
  /* Typography */
  --perxis-auto-tabs-content-font-family-inner: var(
    --perxis-auto-tabs-content-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --perxis-auto-tabs-content-font-size-inner: var(
    --perxis-auto-tabs-content-font-size,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --perxis-auto-tabs-content-font-weight-inner: var(
    --perxis-auto-tabs-content-font-weight,
    var(--perxis-auto-root-typography-main-font-weight-inner)
  );
  --perxis-auto-tabs-content-letter-spacing-inner: var(
    --perxis-auto-tabs-content-letter-spacing,
    var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --perxis-auto-tabs-content-line-height-inner: var(
    --perxis-auto-tabs-content-line-height,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-tabs-content-text-transform-inner: var(
    --perxis-auto-tabs-content-text-transform,
    var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --perxis-auto-tabs-content-font-variant-numeric-inner: var(
    --perxis-auto-tabs-content-font-variant-numeric,
    var(--perxis-auto-root-typography-main-font-variant-numeric-inner)
  );
  --perxis-auto-tabs-content-color-inner: var(
    --perxis-auto-tabs-content-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-tabs-item-label-font-family-inner: var(
    --perxis-auto-tabs-item-label-font-family,
    var(--perxis-auto-root-typography-h3-font-family-inner)
  );
  --perxis-auto-tabs-item-label-font-weight-inner: var(
    --perxis-auto-tabs-item-label-font-weight,
    var(--perxis-auto-root-typography-h3-font-weight-inner)
  );
  --perxis-auto-tabs-item-label-letter-spacing-inner: var(
    --perxis-auto-tabs-item-label-letter-spacing,
    var(--perxis-auto-root-typography-h3-letter-spacing-inner)
  );
  --perxis-auto-tabs-item-label-text-transform-inner: var(
    --perxis-auto-tabs-item-label-text-transform,
    var(--perxis-auto-root-typography-h3-text-transform-inner)
  );
  --perxis-auto-tabs-item-label-line-height-inner: var(
    --perxis-auto-tabs-item-label-line-height,
    var(--perxis-auto-root-typography-h3-line-height-inner)
  );
  --perxis-auto-tabs-item-label-font-size-xxs-xs-inner: var(
    --perxis-auto-tabs-item-label-font-size-xxs-xs,
    var(--perxis-auto-root-typography-h4-font-size-xxl-inner)
  );
  --perxis-auto-tabs-item-label-font-size-sm-xxl-inner: var(
    --perxis-auto-tabs-item-label-font-size-sm-xxl,
    var(--perxis-auto-root-typography-h3-font-size-xxl-inner)
  );
  --perxis-auto-tabs-item-label-color-inner: var(
    --perxis-auto-tabs-item-label-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  --perxis-auto-tabs-active-item-label-color-inner: var(
    --perxis-auto-tabs-active-item-label-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-tabs-nav-operations-color-inner: var(
    --perxis-auto-tabs-nav-operations-color,
    var(--perxis-auto-root-typography-color-light-colorful-inner)
  );
  /* End Typography */
  /* Margin */
  --perxis-auto-tabs-nav-margin-inner: var(
    --perxis-auto-tabs-nav-margin,
    0 0 var(--perxis-auto-gap-vertical-sky-inner) 0
  );
  /* End Margin */
  --antd-wave-shadow-color: transparent;
  --wave-color: transparent;
}
.perxis-auto-1_16_0-tabs[ant-5_17_0-click-animating-without-extra-node=true]::after,
.perxis-auto-1_16_0-tabs > *[ant-5_17_0-click-animating-without-extra-node=true]::after {
  animation: none !important;
}
.perxis-auto-1_16_0-tabs .ant-5_17_0-wave {
  transition: none !important;
}
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs {
  color: var(--perxis-auto-tabs-content-color-inner);
}
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs .ant-5_17_0-tabs-tab {
  background: transparent;
  padding: 0;
  user-select: none;
}
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs .ant-5_17_0-tabs-tab .ant-5_17_0-tabs-tab-btn {
  text-shadow: none;
}
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs .ant-5_17_0-tabs-tab .ant-5_17_0-tabs-tab-btn .perxis-auto-1_16_0-tabs__item-label {
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-tabs-item-label-color-inner);
  --perxis-auto-typography-h3-font-family: var(--perxis-auto-tabs-item-label-font-family-inner);
  --perxis-auto-typography-h3-font-weight: var(--perxis-auto-tabs-item-label-font-weight-inner);
  --perxis-auto-typography-h3-letter-spacing: var(--perxis-auto-tabs-item-label-letter-spacing-inner);
  --perxis-auto-typography-h3-text-transform: var(--perxis-auto-tabs-item-label-text-transform-inner);
  --perxis-auto-typography-h3-font-size-xxs: var(--perxis-auto-tabs-item-label-font-size-xxs-xs-inner);
  --perxis-auto-typography-h3-font-size-xs: var(--perxis-auto-tabs-item-label-font-size-xxs-xs-inner);
  --perxis-auto-typography-h3-font-size-sm: var(--perxis-auto-tabs-item-label-font-size-sm-xxl-inner);
  --perxis-auto-typography-h3-font-size-md: var(--perxis-auto-tabs-item-label-font-size-sm-xxl-inner);
  --perxis-auto-typography-h3-font-size-lg: var(--perxis-auto-tabs-item-label-font-size-sm-xxl-inner);
  --perxis-auto-typography-h3-font-size-xl: var(--perxis-auto-tabs-item-label-font-size-sm-xxl-inner);
  --perxis-auto-typography-h3-font-size-xxl: var(--perxis-auto-tabs-item-label-font-size-sm-xxl-inner);
  --perxis-auto-typography-h3-line-height-xxs: var(--perxis-auto-tabs-item-label-line-height-inner);
  --perxis-auto-typography-h3-line-height-xs: var(--perxis-auto-tabs-item-label-line-height-inner);
  --perxis-auto-typography-h3-line-height-sm: var(--perxis-auto-tabs-item-label-line-height-inner);
  --perxis-auto-typography-h3-line-height-md: var(--perxis-auto-tabs-item-label-line-height-inner);
  --perxis-auto-typography-h3-line-height-lg: var(--perxis-auto-tabs-item-label-line-height-inner);
  --perxis-auto-typography-h3-line-height-xl: var(--perxis-auto-tabs-item-label-line-height-inner);
  --perxis-auto-typography-h3-line-height-xxl: var(--perxis-auto-tabs-item-label-line-height-inner);
}
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs .ant-5_17_0-tabs-tab.ant-5_17_0-tabs-tab-active .ant-5_17_0-tabs-tab-btn {
  text-shadow: none;
}
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs .ant-5_17_0-tabs-tab.ant-5_17_0-tabs-tab-active .ant-5_17_0-tabs-tab-btn .perxis-auto-1_16_0-tabs__item-label {
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-tabs-active-item-label-color-inner);
}
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs .ant-5_17_0-tabs-tab + .ant-5_17_0-tabs-tab {
  margin: 0 0 0 var(--perxis-auto-gap-horizontal-inner);
}
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs .ant-5_17_0-tabs-ink-bar {
  display: none;
}
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs.ant-5_17_0-tabs-top > .ant-5_17_0-tabs-nav, .perxis-auto-1_16_0-tabs.ant-5_17_0-tabs.ant-5_17_0-tabs-bottom > .ant-5_17_0-tabs-nav, .perxis-auto-1_16_0-tabs.ant-5_17_0-tabs.ant-5_17_0-tabs-top > div > .ant-5_17_0-tabs-nav, .perxis-auto-1_16_0-tabs.ant-5_17_0-tabs.ant-5_17_0-tabs-bottom > div > .ant-5_17_0-tabs-nav {
  margin: var(--perxis-auto-tabs-nav-margin-inner);
}
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs.ant-5_17_0-tabs-top > .ant-5_17_0-tabs-nav .ant-5_17_0-tabs-nav-wrap::after, .perxis-auto-1_16_0-tabs.ant-5_17_0-tabs.ant-5_17_0-tabs-bottom > .ant-5_17_0-tabs-nav .ant-5_17_0-tabs-nav-wrap::after, .perxis-auto-1_16_0-tabs.ant-5_17_0-tabs.ant-5_17_0-tabs-top > div > .ant-5_17_0-tabs-nav .ant-5_17_0-tabs-nav-wrap::after, .perxis-auto-1_16_0-tabs.ant-5_17_0-tabs.ant-5_17_0-tabs-bottom > div > .ant-5_17_0-tabs-nav .ant-5_17_0-tabs-nav-wrap::after, .perxis-auto-1_16_0-tabs.ant-5_17_0-tabs.ant-5_17_0-tabs-top > .ant-5_17_0-tabs-nav .ant-5_17_0-tabs-nav-wrap::before, .perxis-auto-1_16_0-tabs.ant-5_17_0-tabs.ant-5_17_0-tabs-bottom > .ant-5_17_0-tabs-nav .ant-5_17_0-tabs-nav-wrap::before, .perxis-auto-1_16_0-tabs.ant-5_17_0-tabs.ant-5_17_0-tabs-top > div > .ant-5_17_0-tabs-nav .ant-5_17_0-tabs-nav-wrap::before, .perxis-auto-1_16_0-tabs.ant-5_17_0-tabs.ant-5_17_0-tabs-bottom > div > .ant-5_17_0-tabs-nav .ant-5_17_0-tabs-nav-wrap::before {
  content: none;
  box-shadow: none;
}
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs .ant-5_17_0-tabs-nav::before {
  display: none;
}
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs .ant-5_17_0-tabs-nav-operations [class^=ant-5_17_0-tabs],
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs .ant-5_17_0-tabs-nav-operations [class*=" ant-5_17_0-tabs"] {
  color: var(--perxis-auto-tabs-nav-operations-color-inner);
}
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs > .ant-5_17_0-tabs-nav .ant-5_17_0-tabs-nav-operations > * {
  cursor: pointer;
  padding: 5px 8px;
}
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs .ant-5_17_0-tabs-content {
  color: var(--perxis-auto-tabs-content-color-inner);
}
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs .ant-5_17_0-tabs-content [class^=ant-5_17_0-tabs],
.perxis-auto-1_16_0-tabs.ant-5_17_0-tabs .ant-5_17_0-tabs-content [class*=" ant-5_17_0-tabs"] {
  font-family: var(--perxis-auto-tabs-content-font-family-inner);
  font-size: var(--perxis-auto-tabs-content-font-size-inner);
  line-height: var(--perxis-auto-tabs-content-line-height-inner);
  font-weight: var(--perxis-auto-tabs-content-font-weight-inner);
  text-transform: var(--perxis-auto-tabs-content-text-transform-inner);
  letter-spacing: var(--perxis-auto-tabs-content-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-tabs-content-font-variant-numeric-inner);
}
.perxis-auto-1_16_0-tabs--hidden-operations.ant-5_17_0-tabs > .ant-5_17_0-tabs-nav .ant-5_17_0-tabs-nav-operations, .perxis-auto-1_16_0-tabs--hidden-operations.ant-5_17_0-tabs > div > .ant-5_17_0-tabs-nav .ant-5_17_0-tabs-nav-operations {
  display: none;
}

.perxis-auto-1_16_0-tabs-dropdown {
  /* Typography */
  --perxis-auto-tabs-dropdown-font-family-inner: var(
    --perxis-auto-tabs-dropdown-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-tabs-dropdown-font-size-inner: var(
    --perxis-auto-tabs-dropdown-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-tabs-dropdown-font-weight-inner: var(
    --perxis-auto-tabs-dropdown-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-tabs-dropdown-letter-spacing-inner: var(
    --perxis-auto-tabs-dropdown-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-tabs-dropdown-line-height-inner: var(
    --perxis-auto-tabs-dropdown-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-tabs-dropdown-text-transform-inner: var(
    --perxis-auto-tabs-dropdown-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-tabs-dropdown-color-inner: var(
    --perxis-auto-tabs-dropdown-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
  /* End Border */
  --perxis-auto-tabs-dropdown-border-radius-inner: var(--perxis-auto-tabs-dropdown-border-radius, 8px);
  /* End Border */
  /* Colors */
  --perxis-auto-tabs-dropdown-background-color-inner: var(
    --perxis-auto-tabs-dropdown-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-tabs-dropdown-hover-background-color-inner: var(
    --perxis-auto-tabs-dropdown-background-color,
    var(--perxis-auto-root-seventh-color-inner)
  );
  /* End Colors */
  /* Z-index */
  --perxis-auto-tabs-dropdown-z-index-inner: var(--perxis-auto-tabs-dropdown-z-index, 1030);
  /* End Z-index */
  --antd-wave-shadow-color: transparent;
  --wave-color: transparent;
}
.perxis-auto-1_16_0-tabs-dropdown[ant-5_17_0-click-animating-without-extra-node=true]::after,
.perxis-auto-1_16_0-tabs-dropdown > *[ant-5_17_0-click-animating-without-extra-node=true]::after {
  animation: none !important;
}
.perxis-auto-1_16_0-tabs-dropdown .ant-5_17_0-wave {
  transition: none !important;
}
.perxis-auto-1_16_0-tabs-dropdown.ant-5_17_0-tabs-dropdown {
  z-index: var(--perxis-auto-tabs-dropdown-z-index-inner);
}
.perxis-auto-1_16_0-tabs-dropdown.ant-5_17_0-tabs-dropdown .ant-5_17_0-tabs-dropdown-menu {
  background-color: var(--perxis-auto-tabs-dropdown-background-color-inner);
  border-radius: var(--perxis-auto-tabs-dropdown-border-radius-inner);
  padding: 0;
}
.perxis-auto-1_16_0-tabs-dropdown.ant-5_17_0-tabs-dropdown,
.perxis-auto-1_16_0-tabs-dropdown.ant-5_17_0-tabs-dropdown .ant-5_17_0-tabs-dropdown-menu-item {
  font-family: var(--perxis-auto-tabs-dropdown-font-family-inner);
  font-size: var(--perxis-auto-tabs-dropdown-font-size-inner);
  line-height: var(--perxis-auto-tabs-dropdown-line-height-inner);
  font-weight: var(--perxis-auto-tabs-dropdown-font-weight-inner);
  text-transform: var(--perxis-auto-tabs-dropdown-text-transform-inner);
  letter-spacing: var(--perxis-auto-tabs-dropdown-letter-spacing-inner);
  color: var(--perxis-auto-tabs-dropdown-color-inner);
}
.perxis-auto-1_16_0-tabs-dropdown.ant-5_17_0-tabs-dropdown .ant-5_17_0-tabs-dropdown-menu-item {
  padding: 6px 15px;
}
.perxis-auto-1_16_0-tabs-dropdown.ant-5_17_0-tabs-dropdown .ant-5_17_0-tabs-dropdown-menu-item:hover {
  background-color: var(--perxis-auto-tabs-dropdown-hover-background-color-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
